import React from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../../components/ui/carousel";
import { Link, useNavigate } from "react-router-dom";
import { amadeusServices } from "../services/priceList";

export default function BeautyFactory() {
  const nav = useNavigate();
  const [showDiv, setShowDiv] = React.useState(null);
  const options = {
    skipSnaps: true,
  };

  return (
    <div className="flex flex-col justify-between items-center w-100 relative">
      <div className="flex flex-col gap-2 mb-10 w-100 items-center">
        <h3 className="sm:text-3xl font-medium text-xl font-montserrat text-center">
          SERVICES
        </h3>
        <p className="text-center text-sm opacity-80">
          <span>How about some "me, myself and eye"</span>
        </p>
        <Link
          to={`/services`}
          className="text-center underline text-[12px] font-medium mt-1 "
        >
          VIEW ALL
        </Link>
      </div>
      <Carousel opts={options}>
        <CarouselContent className="flex gap-5 ml-0">
          {amadeusServices?.map((i: any) => (
            <CarouselItem
              className={
                "lg:basis-1/5 basis-1/2 p-0 relative"
              }
              key={i.id}
            >
              <Link to={i.link}>
                <img
                  src={i.image}
                  alt="carousel-img"
                  className="w-full"
                />

                <p
                  className={`flex justify-center items-end absolute bottom-0 pb-2 text-xl w-full text-white text-center h-1/3 bg-gradient-to-t from-neutral-900 `}
                >
                  <span> {i.service}</span>
                </p>
              </Link>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="z-30 left-0 absolute h-full rounded-none opacity-25 hover:opacity-75 border-none sm:w-12 bg-neutral-200 dark:bg-neutral-900" />
        <CarouselNext className="absolute z-30 right-0  h-full rounded-none opacity-25 hover:opacity-75 border-none sm:w-12 bg-neutral-200 dark:bg-neutral-900" />
      </Carousel>
    </div>
  );
}
